import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const styles = () => ({
  root: {
    textTransform: (props) => {
      if (props.capitalize) {
        return 'capitalize';
      }
      if (props.lowerCase) {
        return 'lowercase';
      }
      if (props.upperCase) {
        return 'uppercase';
      }
      return 'none';
    },
  },
});

type Props = {
  capitalize: boolean,
  children: React.ReactChildren,
  lowerCase: boolean,
  upperCase: boolean,
};

/**
 * Text Transform Component
 * @param {Props} props
 */
function TextTransform({
  capitalize = false, children, lowerCase = false, upperCase = false,
}: Props) {
  const classes = makeStyles(styles)({ capitalize, lowerCase, upperCase });
  return <span className={classes.root}>{children}</span>;
}

export default TextTransform;
